import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import Project from '@/projects/entities/project'
import cloneDeep from 'lodash/cloneDeep'
import Folder from '@/folders/entities/folder'
import foldersService from '@/folders/services/folders-service'
import FoldersRequest from '@/folders/requests/folders-request'

@Component
export default class CreateProjectDialog extends Vue {
  @Ref()
  protected validator!: ValidationObserver

  protected dialog = false
  protected editMode = false
  protected roundedCorners = false
  protected model!: Project

  private file = new File([], '')

  private folders: string[] | null = null

  private selectedFolder = null

  public async create(model: Project) {
    this.model = model
    this.file = new File([], '')
    this.dialog = true
    this.editMode = false
    this.folders = await foldersService.loadAllNamesAsync()
    this.reset()
  }

  public async edit(model: Project) {
    this.model = cloneDeep(model)
    this.file = new File([], '')
    this.dialog = true
    this.editMode = true
    this.folders = await foldersService.loadAllNamesAsync()
    this.reset()
  }

  public close() {
    this.dialog = false
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }

  private imageSelected(file: File) {
    if (file.size > 0) {
      this.model.image = file
    }
  }

  private async save() {
    if (await this.validator.validate()) {
      this.$emit(this.editMode ? 'update' : 'create', this.model)
    }
  }
}
